import { motion } from "framer-motion";
import { SCREENS, COACH_SCREENS } from "@/lib/assets";
import { PhoneFrame } from "@/components/landing/Hero";
import { useLang } from "@/i18n/LanguageContext";

const imgs = [
  COACH_SCREENS.coachShare,
  SCREENS.rechercheAliments,
  SCREENS.ajoutIntelligent,
  SCREENS.repasSurprise,
  SCREENS.journeeLuna,
  SCREENS.dupliquer,
  SCREENS.exportPdf,
  SCREENS.recettes,
  SCREENS.health,
  SCREENS.bilanMetabolique,
  SCREENS.corps,
  SCREENS.bilanMois,
  SCREENS.cycle,
  SCREENS.progress,
  COACH_SCREENS.coachHome,
  COACH_SCREENS.coachPrograms,
  COACH_SCREENS.coachNutrition,
  COACH_SCREENS.coachReminders,
  COACH_SCREENS.coachExercise,
  COACH_SCREENS.coachRestTimer,
];

export const Preview = () => {
  const { t } = useLang();
  return (
    <section id="apercu" data-testid="preview-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400">
            {t.preview.overline}
          </span>
          <h2 className="mt-4 font-outfit text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            {t.preview.title}
          </h2>
          <p className="mt-4 text-lg text-slate-400">{t.preview.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8">
          {t.preview.screens.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`preview-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              className="group text-center"
            >
              <div className="relative">
                <div className="absolute -inset-x-6 -bottom-8 h-28 bg-emerald-500/20 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <PhoneFrame
                  src={imgs[i]}
                  alt={s.title}
                  className="relative mx-auto max-w-[210px] transition-transform duration-500 group-hover:-translate-y-1.5"
                />
              </div>
              <h3 className="mt-5 font-outfit font-bold text-white">{s.title}</h3>
              <p className="text-sm text-slate-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
